import { useTheme } from '@mui/material/styles';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { gtm } from '../lib/gtm';
import Head from 'next/head';

export const MaintenanceComponent = () => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Head>
        <title>Maintenance | Onderhoudsconfigurator</title>
      </Head>
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.paper',
          display: 'flex',
          flexGrow: 1,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Typography align="center" variant={mobileDevice ? 'h4' : 'h1'}>
            Even geduld, we zijn bezig met updates
          </Typography>
          <Typography align="center" color="textSecondary" sx={{ mt: 0.2 }} variant="subtitle2">
            Onze servers worden momenteel bijgewerkt om de service te verbeteren. We zijn zo snel mogelijk weer online.
            Bedankt voor je begrip.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6,
            }}
          >
            <Box
              alt="Under development"
              component="img"
              src={`/static/error/error401_${theme.palette.mode}.svg`}
              sx={{
                height: 450,
                maxWidth: '100%',
                width: 400,
              }}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};
